export const isArray = arr => Array.isArray(arr) && arr.length > 0;
